import { ICardForm } from '@/interface';

export const baseFormCard: ICardForm = {
  key: 'base',
  title: '基本信息',
  fieldsConfig: [
    {
      props: 'id',
      label: '唯一ID：（id）',
      render: 'hidden',
      uiOptions: {
        disabled: true,
      },
    },
    {
      props: '',
      render: 'formTitle',
      uiOptions: {
        title: '首页配置',
      },
    },
    {
      props: 'name',
      label: '配置名称',
      render: 'input',
      className: 'row-2-left',
      uiOptions: {
        placeholder: '请输入配置名称',
      },
    },
    {
      props: 'twoColumnLayout',
      label: '双列流置顶',
      className: 'row-2',
      render: 'customNovelSelect',
    },
    {
      props: 'itemList',
      label: '配置列表',
      render: 'customNovelHomeIndex',
      uiOptions: {
        drag: true,
        dataType: 'story',
      },
    },
  ],
};
